"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useResetTimer = void 0;
const react_1 = require("react");
const usePrevious_1 = require("./usePrevious");
const useResetTimer = (timer, resetTime, callback) => {
    const prevResetTime = (0, usePrevious_1.usePrevious)(resetTime);
    (0, react_1.useEffect)(() => {
        if (timer && +resetTime && prevResetTime !== resetTime) {
            callback();
        }
    }, [prevResetTime, resetTime, callback, timer]);
};
exports.useResetTimer = useResetTimer;
//# sourceMappingURL=useResetTimer.js.map